// store/news/sagas/update-news-saga.js
import { call, put, takeLatest } from 'redux-saga/effects';
import { updateNews } from '../../../services/news/news-service';
import {
    UPDATE_NEWS_REQUEST,
    updateNewsSuccess,
    updateNewsFailure,
} from '../actions/update-news-actions';

function* handleUpdateNews(action) {
    try {
        const { id, formData } = action.payload;
        const result = yield call(updateNews, id, formData);
        yield put(updateNewsSuccess(result));
    } catch (error) {
        yield put(updateNewsFailure(error));
    }
}

export function* watchUpdateNews() {
    yield takeLatest(UPDATE_NEWS_REQUEST, handleUpdateNews);
}
